/**
 * 日志级别相关函数.
 *
 * @author  yusangeng@outlook.com
 */
/**
 * 字符串/数字转为日志级别数字.
 *
 * '1'会被转为1, 'DEBUG'会被转为0, 其他字符串一律转为0,
 * 如果是数字, 则向下取整输出, 如果是其他类型, 则一律转为0.
 *
 * @param {any} value
 * @returns {number} 日志级别数字
 *
 * @private
 */
export function anything2Level(value) {
    if (typeof value === "number") {
        return Math.floor(value);
    }
    if (typeof value === "string") {
        var parsedValue = parseInt(value);
        if (!isNaN(parsedValue)) {
            return parsedValue;
        }
        var level = ["DEBUG", "INFO", "WARN", "ERROR", "MUTE"].indexOf(value.toUpperCase());
        if (level < 0) {
            level = 0;
        }
        return level;
    }
    return 0;
}
/**
 * level转为字符串.
 *
 * @param {any} level 日志级别
 * @returns {string} 日志级别字符串
 *
 * @private
 */
export function anything2LevelString(level) {
    var nLevel = anything2Level(level);
    return (["DEBUG", "INFO", "WARN", "ERROR", "MUTE"][nLevel] || "LEVEL(".concat(level, ")"));
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGV2ZWxIZWxwZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvbGV2ZWxIZWxwZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7R0FJRztBQUVIOzs7Ozs7Ozs7O0dBVUc7QUFDSCxNQUFNLFVBQVUsY0FBYyxDQUFDLEtBQVU7SUFDdkMsSUFBSSxPQUFPLEtBQUssS0FBSyxRQUFRLEVBQUU7UUFDN0IsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQyxDQUFDO0tBQzFCO0lBRUQsSUFBSSxPQUFPLEtBQUssS0FBSyxRQUFRLEVBQUU7UUFDN0IsSUFBTSxXQUFXLEdBQUcsUUFBUSxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBRXBDLElBQUksQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLEVBQUU7WUFDdkIsT0FBTyxXQUFXLENBQUM7U0FDcEI7UUFFRCxJQUFJLEtBQUssR0FBRyxDQUFDLE9BQU8sRUFBRSxNQUFNLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBRSxNQUFNLENBQUMsQ0FBQyxPQUFPLENBQzVELEtBQUssQ0FBQyxXQUFXLEVBQUUsQ0FDcEIsQ0FBQztRQUVGLElBQUksS0FBSyxHQUFHLENBQUMsRUFBRTtZQUNiLEtBQUssR0FBRyxDQUFDLENBQUM7U0FDWDtRQUVELE9BQU8sS0FBSyxDQUFDO0tBQ2Q7SUFFRCxPQUFPLENBQUMsQ0FBQztBQUNYLENBQUM7QUFFRDs7Ozs7OztHQU9HO0FBQ0gsTUFBTSxVQUFVLG9CQUFvQixDQUFDLEtBQVU7SUFDN0MsSUFBTSxNQUFNLEdBQUcsY0FBYyxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQ3JDLE9BQU8sQ0FDTCxDQUFDLE9BQU8sRUFBRSxNQUFNLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBRSxNQUFNLENBQUMsQ0FBQyxNQUFNLENBQUMsSUFBSSxnQkFBUyxLQUFLLE1BQUcsQ0FDeEUsQ0FBQztBQUNKLENBQUMifQ==